import React, { useState, useEffect } from 'react';
import { Button, Form, Grid, Header, Image, Message, Segment, Input, Icon, Divider, Card, List, Rating, Popup } from 'semantic-ui-react'

export default function Inventions() {

    //useStates

    const [loading, setLoading] = useState(false);

    const [inputDevice, setInputDevice] = useState('');
    const [inputName, setInputName] = useState('');
    const [inputSlogan, setInputSlogan] = useState('');
    const [inputDes, setInputDes] = useState('');
    const [inputDesShort, setInputDesShort] = useState('');

    const [inputUses, setInputUses] = useState('');
    const [usesArray, SetUsesArray] = useState([]);

    const [inputTodo, setInputTodo] = useState('');
    const [todoArray, setTodoArray] = useState([]);

    const [inputRating, setInputRating] = useState([]);

    const [inputModel0, setInputModel0] = useState('');
    const [inputModel1, setInputModel1] = useState('');
    const [inputModel2, setInputModel2] = useState('');
    const [inputModel3, setInputModel3] = useState('');

    const [blue1, setBlue1] = useState('');
    const [blue2, setBlue2] = useState('');

    const [inputAdvert1, setInputAdvert1] = useState('');

    const [inputKey, setInputKey] = useState('');

    const [inputAdvert2, setInputAdvert2] = useState('');
    const [inputAdvert3, setInputAdvert3] = useState('');
    const [imageUrls, setImageUrls] = useState([inputAdvert1, inputAdvert2, inputAdvert3]);
    const [currentIndex, setCurrentIndex] = useState(1);

    //Configure OpenAI

    const { Configuration, OpenAIApi } = require("openai");
    const configuration = new Configuration({
        apiKey: inputKey,
    });
    const openai = new OpenAIApi(configuration);

    //Fetch Functions

    const getName = async () => {
        setLoading(true);
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "Create a unique 1-5 word name for the following invention: " + inputDevice + " do not use the words in the text " + inputDevice + ".",
            max_tokens: 256,
            temperature: 0.9,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputName(response.data.choices[0].text)
        })
    };

    const getMain = async () => {
        setLoading(true);
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: 'Create a random new invention that has never been made, with a 1-5 word name.',
            max_tokens: 256,
            temperature: 0.9,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputName(response.data.choices[0].text)
        })
    };

    //This is called last, so turns loading off.

    useEffect(() => {
        if (inputAdvert1) {
            setLoading(false);
        }
    }, [inputAdvert1]);

    const getAdvert1 = async () => {
        openai.createImage({
            prompt: "A poster advertising the " + inputName + "a " + inputDesShort + ". Modern poster, 3D, poster art, cool, photorealistic, beautiful.",
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputAdvert1(response.data.data[0].url)
        })
    };

    // Main Fetch Functions

    const getSlogan = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "Create a short slogan for a unique invention " + inputDevice + " called the " + inputName + ", without mentioning it by name.",
            max_tokens: 25,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputSlogan(response.data.choices[0].text)
        })
    };

    const getDescription = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "Create a beautifully written description for an invention " + inputDevice + " called the " + inputName + ".",
            max_tokens: 256,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputDes(response.data.choices[0].text)
        })
    };

    //Please summarize this description:
    const getDescriptionShort = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            //prompt: "Create a physical description in very short 15 word max sentence of the following invention's appearance, it is described as " + inputDes + ", without mentioning it by name.",
            prompt: "Please summarize this description: '" + inputDes + "'in 15 words or less, focusing on the physical aspects of the invention, without mentioning it by name.",
            max_tokens: 30,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputDesShort(response.data.choices[0].text)
        })
    };

    const getToDo = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "Create a to-do list of the 10 steps required to create the following product: '" + inputDes + "', format the response as a valid JSON array with 10 elements.",
            max_tokens: 256,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputTodo(response.data.choices[0].text)
        })
    };

    const getUses = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "List four uses for a new invention, with the following description:" + inputDes + ", format the response as a valid JSON array with four elements.",
            max_tokens: 256,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            setInputUses(response.data.choices[0].text)
        })
    };

    //If response is not JSON, set ratings randomly. Check this.

    const getRatings = async () => {
        openai.createCompletion({
            model: "text-davinci-003",
            prompt: "From 0 to 5 what number would you give the weight, price, complexity and ETA of the following invention: '" + inputDes + "', format the response as a valid JSON array with 4 elements where each element is a number.",
            max_tokens: 256,
            temperature: 0.7,
            presence_penalty: 0.2,
            frequency_penalty: 0.2,
        }).then((response) => {
            try {
                setInputRating(JSON.parse(response.data.choices[0].text))
            } catch (e) {
                const ratings = Array.from({ length: 4 }, () => Math.floor(Math.random() * 5) + 1);
                setInputRating(ratings);
            }
        })
    };

    //Description useEffects - Check

    useEffect(() => {
        if (inputName) {
            getSlogan();
            getDescription();
        }
    }, [inputName]);

    useEffect(() => {
        if (inputDes) {
            getDescriptionShort();
            getRatings();
        }
    }, [inputDes]);

    useEffect(() => {
        if (inputTodo) {
            try {
                setTodoArray(JSON.parse(inputTodo));
            } catch (e) {
                getToDo();
                console.log("This didn't work" + inputTodo);
            }
        }
    }, [inputTodo]);

    useEffect(() => {
        if (inputUses) {
            try {
                SetUsesArray(JSON.parse(inputUses));
            } catch (e) {
                getUses();
                console.log("This does not work:" + inputUses);
            }
        }
    }, [inputUses]);

    useEffect(() => {
        if (inputDes) {
            getUses();
            getToDo();
        }
    }, [inputDes]);

    //Image Fetch Functions

    var prompts = [", digital art, 3D style.", ", 3D point cloud from LiDAR sensor data, on a solid black background.", ", modern flat design style illustration with line elements.", ", drawing, schematic.",]

    const getModel0 = async () => {
        openai.createImage({
            prompt: inputDesShort + prompts[0],
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputModel0(response.data.data[0].url)
        })
    };

    const getModel1 = async () => {
        openai.createImage({
            prompt: inputDesShort + prompts[1],
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputModel1(response.data.data[0].url)
        })
    };

    const getModel2 = async () => {
        openai.createImage({
            prompt: inputDesShort + prompts[2],
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputModel2(response.data.data[0].url)
        })
    };

    const getModel3 = async () => {
        openai.createImage({
            prompt: inputDesShort + prompts[3],
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputModel3(response.data.data[0].url)
        })
    };

    var blueprompts = [", schematic blueprint, blue background, white details", ", blueprint, scientific diagram, blue background, white details",]

    const getBlue1 = async () => {
        openai.createImage({
            prompt: inputName + " ," + inputDesShort + blueprompts[0] + ".",
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setBlue1(response.data.data[0].url)
        })
    };

    const getBlue2 = async () => {
        openai.createImage({
            prompt: inputName + " ," + inputDesShort + blueprompts[1] + ".",
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setBlue2(response.data.data[0].url)
        })
    };

    //Additional Adverts, user clicks arrow to see more.

    const adprompts = ["A poster advertising the " + inputName + ", " + inputDesShort + " Modern poster, 3D, poster art, cool, photorealistic, beautiful.", "A poster advertising " + inputName + ", " + inputDesShort + " Advertisment, poster art, cool, digital art, beautiful.", inputName + ", " + inputDesShort + " 60s Advert, digital art."]

    const getAdvert2 = async () => {
        openai.createImage({
            prompt: "A poster advertising a " + inputName + "a " + inputDesShort + ". Advertisment, poster art, cool, digital art, beautiful.",
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputAdvert2(response.data.data[0].url)
        })
    };

    const getAdvert3 = async () => {
        openai.createImage({
            prompt: inputName + "a " + inputDesShort + ". 60s Advert, digital art.",
            n: 1,
            size: "1024x1024",
        }).then((response) => {
            setInputAdvert3(response.data.data[0].url)
        })
    };

    //Function To Alternate Between Adverts

    const handleClick = (direction) => {
        if (direction === 'left') {
            if (currentIndex === 0) {
                setCurrentIndex(imageUrls.length - 1);
            } else {
                setCurrentIndex(currentIndex - 1);
            }
        } else if (direction === 'right') {
            if (currentIndex === imageUrls.length - 1) {
                setCurrentIndex(0);
            } else {
                setCurrentIndex(currentIndex + 1);
            }
        }
    }

    useEffect(() => {
        if (inputAdvert1 && inputAdvert2 && inputAdvert3) {
            setImageUrls([inputAdvert1, inputAdvert2, inputAdvert3]);
        }
    }, [inputAdvert1, inputAdvert2, inputAdvert3]);

    //Image useEffects - Check

    useEffect(() => {
        if (inputName && inputDesShort) {
            getBlue1();
            getBlue2();
            getAdvert1();
            getAdvert2();
            getAdvert3();
        }
    }, [inputName, inputDesShort]);

    useEffect(() => {
        if (inputDesShort) {
            getModel0();
            getModel1();
            getModel2();
            getModel3();
        }
    }, [inputDesShort]);

    //Download Text into a .txt, later make it so you can download an image of the message and share it to twitter.

    const downloadImage = () => {
        const text = inputName + '\n' + inputSlogan + '\n' + inputDes + '\n' + '\n' + '1. ' + usesArray[0] + ' 2. ' + usesArray[1] + ' 3. ' + usesArray[2] + ' 4. ' + usesArray[3] +
            '\n' + '\n' + '1. ' + todoArray[0] + ' 2. ' + todoArray[1] + ' 3. ' + todoArray[2] + ' 4. ' + todoArray[3] + ' 5. ' + todoArray[4] + ' 6. ' + todoArray[5] + ' 7. ' +
            todoArray[6] + ' 8. ' + todoArray[7] + ' 9. ' + todoArray[8] + ' 10. ' + todoArray[9];
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', 'MyAInvention.txt');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    return (
        <div className="abody">
            <div className='app-body'>

                <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle' >
                    <Grid.Column style={{ maxWidth: 850 }} >

                        <Segment.Group raised  >
                            <Segment stackable style={{ padding: 25 }}>

                                <Header as='h1' color='#3057E1' textAlign='center'>
                                    <Image src='https://i.imgur.com/siyepD7.png' style={{maxWidth: '40px'}} />
                                    <Header.Content><em>AI</em>nventions</Header.Content>
                                    <Header.Subheader style={{ marginTop: '5px', color: "black" }} >Want to come up with a wacky invention but have no idea how to start? <p></p> Let AIssist you...</Header.Subheader>
                                </Header>
                                <Header as='h5' color='#3057E1' textAlign='center'>
                                    <Header.Content>API KEY: <Input style={{ width: 350 }}
                                        placeholder=""
                                        onChange={(e) => setInputKey(e.target.value)}
                                    /></Header.Content>
                                </Header>
                                <Divider></Divider>
                                <p></p>
                                <Grid columns={2} textAlign='center'>
                                    <Grid.Row verticalAlign="top" style={{ height: "184px" }}>
                                        <Grid.Column>

                                            <Header icon>
                                                <Icon name='write' style={{ color: "#3057E1" }} />
                                                Write Your Idea
                                            </Header>

                                            <p></p>

                                            <Form.Group widths='equal'>
                                                <Form.Field
                                                    control={Input}
                                                    placeholder=""
                                                    onChange={(e) => setInputDevice(e.target.value)}
                                                    action={
                                                        <Button
                                                            animated="fade"
                                                            color="teal"
                                                            size="large"
                                                            onClick={getName}
                                                            style={{ borderRadius: "2px !important" }}
                                                        >
                                                            <Button.Content visible>Go!</Button.Content>
                                                            <Button.Content hidden>
                                                                {!loading && inputAdvert1.length === 0 && (
                                                                    <div>
                                                                        <Icon name="magic" />
                                                                    </div>
                                                                )}
                                                                {loading && (
                                                                    <div>
                                                                        <Icon loading name="spinner" />
                                                                    </div>
                                                                )}
                                                                {!loading && inputAdvert1.length > 0 &&  <Icon name="magic" />}
                                                            </Button.Content>
                                                        </Button>
                                                    }
                                                />
                                            </Form.Group>

                                        </Grid.Column>

                                        <Divider vertical >Or</Divider>

                                        <Grid.Column>

                                            <Header icon>
                                                <Icon name='question' style={{ color: "#3057E1" }} />
                                                Let AI Suggest One
                                            </Header>

                                            <p></p>

                                            <Button animated="fade" icon="magic" color="teal" size="large" onClick={getMain}>
                                                <Button.Content visible>AInspire Me!</Button.Content>
                                                <Button.Content hidden>
                                                    {!loading && inputAdvert1.length === 0 && (
                                                        <div>
                                                            <Icon name="magic" />
                                                        </div>
                                                    )}
                                                    {loading && <div> <Icon loading name='spinner' /></div>}
                                                    {!loading && inputAdvert1.length > 0 &&  <Icon name="magic" />}
                                                </Button.Content>
                                            </Button>

                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Segment.Group>

                        <p></p>
                        <div>

                            <Message
                                style={{
                                    backgroundColor: '#3057E1',
                                    backgroundImage: `
                                          linear-gradient(white 2px, transparent 2px),
                                          linear-gradient(90deg, white 2px, transparent 2px),
                                          linear-gradient(rgba(255,255,255,.3) 1px, transparent 1px),
                                          linear-gradient(90deg, rgba(255,255,255,.3) 1px, transparent 1px),
                                          linear-gradient(to bottom, white, transparent)
                                        `,
                                    backgroundSize: '100px 100px, 100px 100px, 20px 20px, 20px 20px, 100% 100%',
                                    backgroundPosition: '-2px -2px, -2px -2px, -1px -1px, -1px -1px, 0 0',
                                    padding: '20px',
                                    fontFamily: 'Inter, sans-serif'
                                }}
                                floating
                                visible={inputAdvert1.length > 0}
                                hidden={loading || inputAdvert1.length === 0}
                                size='big'
                                attached>

                                <Header as='h2'>
                                    <Header.Content>{inputName}</Header.Content>
                                </Header>

                                <p></p>

                                <Header as='h3'>
                                    <Header.Content>{inputSlogan}</Header.Content>
                                </Header>

                                <Segment>
                                    <p></p>

                                    <Header as='h5'>
                                        <Icon name='pencil' circular />
                                        <Header.Content>{inputDes}</Header.Content>
                                    </Header>

                                    <Divider horizontal><Icon name='cube' />Models</Divider>



                                    <Grid columns={2} divided>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Popup
                                                    position='left center'
                                                    trigger={
                                                        <Card fluid
                                                            image={inputModel0}
                                                            header='3D'
                                                        />
                                                    }>
                                                    <Popup.Content>
                                                        {inputDesShort + prompts[0]}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Popup
                                                    position='right center'
                                                    trigger={
                                                        <Card fluid
                                                            image={inputModel1}
                                                            header='LiDAR'
                                                        />
                                                    }>
                                                    <Popup.Content>
                                                        {inputDesShort + prompts[1]}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Popup
                                                    position='left center'
                                                    trigger={
                                                        <Card fluid
                                                            image={inputModel2}
                                                            header='2D'
                                                        />
                                                    }>
                                                    <Popup.Content>
                                                        {inputDesShort + prompts[2]}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Popup
                                                    position='right center'
                                                    trigger={
                                                        <Card fluid
                                                            image={inputModel3}
                                                            header='Schematic'
                                                        />
                                                    }>
                                                    <Popup.Content>
                                                        {inputDesShort + prompts[3]}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    <Divider horizontal><Icon name='th' /> Uses</Divider>

                                    <Grid columns={2} divided>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Header as='h5'>
                                                    <Icon name='hand point right outline' circular />
                                                    <Header.Content>{usesArray[0]}</Header.Content>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Header as='h5'>
                                                    <Icon name='hand point right outline' circular />
                                                    <Header.Content>{usesArray[1]}</Header.Content>
                                                </Header>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Header as='h5'>
                                                    <Icon name='hand point right outline' circular />
                                                    <Header.Content>{usesArray[2]}</Header.Content>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Header as='h5'>
                                                    <Icon name='hand point right outline' circular />
                                                    <Header.Content>{usesArray[3]}</Header.Content>
                                                </Header>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    <Divider horizontal><Icon name='sort amount up' /> Details</Divider>

                                    <Grid textAlign='center' verticalAlign='middle'>
                                        <Grid.Row columns={4}>
                                            <Grid.Column>
                                                <Header as='h4'>
                                                    <Icon name='weight' />
                                                    <Header.Content>
                                                        Weight
                                                        <Header.Subheader>
                                                            <Rating icon='star' rating={inputRating[0]} maxRating={5} />
                                                        </Header.Subheader>
                                                    </Header.Content>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Header as='h4'>
                                                    <Icon name='pound' />
                                                    <Header.Content>
                                                        Price
                                                        <Header.Subheader><Rating icon='star' rating={inputRating[1]} maxRating={5} /></Header.Subheader>
                                                    </Header.Content>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Header as='h4'>
                                                    <Icon name='bars' />
                                                    <Header.Content>
                                                        Complexity
                                                        <Header.Subheader><Rating icon='star' rating={inputRating[2]} maxRating={5} /></Header.Subheader>
                                                    </Header.Content>
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Header as='h4'>
                                                    <Icon name='calendar' />
                                                    <Header.Content>
                                                        ETA
                                                        <Header.Subheader><Rating icon='star' rating={inputRating[3]} maxRating={5} /></Header.Subheader>
                                                    </Header.Content>
                                                </Header>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    <Divider horizontal><Icon name='clipboard' />Blueprints</Divider>

                                    <Grid textAlign='center' verticalAlign='middle'>
                                        <Grid.Row>
                                            <Grid.Column width={8}>
                                                <Popup
                                                    position='left center'
                                                    trigger={
                                                        <Image src={blue1} rounded fluid />
                                                    }>
                                                    <Popup.Content>
                                                        {inputName + " ," + inputDesShort + " ," + blueprompts[0] + "."}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                            <Grid.Column width={8}>
                                                <Popup
                                                    position='right center'
                                                    trigger={
                                                        <Image src={blue2} rounded fluid />
                                                    }>
                                                    <Popup.Content>
                                                        {inputName + " ," + inputDesShort + " ," + blueprompts[1] + "."}
                                                    </Popup.Content>
                                                </Popup>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    <Divider horizontal><Icon name='list' /> To Do List</Divider>

                                    <List>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[0]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[1]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[2]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[3]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[4]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[5]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[6]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[7]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[8]}</Header.Content></Header></List.Item>
                                        <List.Item><Header as='h5'><Header.Content>{todoArray[9]}</Header.Content></Header></List.Item>
                                    </List>

                                    <Divider horizontal><Icon name='adversal' /> Advert</Divider>

                                    <Popup
                                        position='right center'
                                        trigger={
                                            <Image src={imageUrls[currentIndex]} fluid rounded />
                                        }>
                                        <Popup.Content>
                                            {adprompts[currentIndex]}
                                        </Popup.Content>
                                    </Popup>

                                    <p></p>

                                    <Button color='teal' icon='arrow left' onClick={() => handleClick('left')}>
                                        <Button.Content visible><Icon name='arrow left' /></Button.Content>
                                    </Button>
                                    <Button color='teal' icon='arrow left' onClick={() => handleClick('right')}>
                                        <Button.Content visible><Icon name='arrow right' /></Button.Content>
                                    </Button>

                                    <Divider horizontal><Icon name='download' /> Download</Divider>
                                    <a onClick={downloadImage} active>Like the invention? Click me to download the text. For images right click and save as.</a>
                                </Segment>
                            </Message>
                        </div>
                    </Grid.Column>
                </Grid>
            </div>
            <Grid textAlign= 'center' >
            <Header as='h5' color='#3057E1' style={{ padding: '10px' }}>
                <Icon name='copyright outline' />
                <Header.Content>2023 XHB</Header.Content>
            </Header>
            </Grid>
        </div >
    )
}

